const React = require('react');
const TextField = require('@material-ui/core/TextField').default;
const onChangeHandler = require("./utils/onChangeHandler");

module.exports = ({
  label,
  helperText,
  className,
  onChange,
  maxLength,
  disableCommas,
  displayMaxLength,
  ...props
}) => {
  const length = props.value ? props.value.length : 0;
  const inputProps = {
    ...(props.inputProps || {}),
  };

  if (maxLength) {
    inputProps.maxLength = maxLength;
  }

  return (
    <div className={'layoutRow fhaS fvaC w ' + (className || '')}>
      <div
        className="c8B8D93 f14 fw5 w(|min)90 pr10 ff$2 __label"
      >{label}</div>
      <div className="fx1 wmin0 rlv">
        <TextField
          margin="none"
          variant="outlined"
          {...props}
          onChange={onChangeHandler({onChange, disableCommas, maxLength})}
          className="
            w (pv17|pt14|ph20|h52|bxzBB)>.*OutlinedInput-input
            o50>.*input.Mui-disabled
            (p0)>.MuiOutlinedInput-multiline
            (dn|f14|fw5|c1D1E20|ff$2)>.*OutlinedInput-root*2
            (r8|b1.5|bcEDEEF0(>*|:h>*|>.*-focused):not[.*-error])>.*-notchedOutline*2
          "
        />
        {
          displayMaxLength && maxLength ? (<div
            className="abs srb5 f10"
          >
          <span
            className={`cF00.active`
              + (length > maxLength ? ' active' : '')}
          >{length}</span> / {maxLength}
          </div>) : null
        }
        {
          props.error ? (<div className="rlv">
            <div
              className="abs sh20 st f12 cEC4C4C fw4"
            >{helperText}</div>
          </div>) : null
        }
        {
          props.description && !props.error ? (<div className="rlv">
            <div
              className="abs sh20 st f12 c8B8D93 fw4"
            >{props.description}</div>
          </div>) : null
        }
      </div>
    </div>
  );
};
